import { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { IMAGE_URL } from "../../config/Config";
import { Link } from "react-router-dom";
import { getData } from "../../redux/utiles/apiUtillity";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { updateFooter } from "../../redux/actions";

const now = moment().format("YYYY-MM-DD");


const FooterPage = () => {
    const dispatch = useDispatch();
    const { footer, _persist } = useSelector((state) => state);
    const [state, setState] = useState({
        loading: false,
        data: {
            brands: [],
            complains: [],
            social: {
                content: "<ul class=\"socials-list\"><li><a href=\"https://www.facebook.com/\" target=\"_blank\" rel=\"noreferrer\"><img src=\"uploads/images/social_fb.png\" alt=\"Facebook\"/></a></li><li><a href=\"https://www.aparat.com/\" target=\"_blank\" rel=\"noreferrer\"><img src=\"uploads/images/social_aparat.png\" alt=\"Aparat\"/></a></li><li><a href=\"https://t.me/\" target=\"_blank\" rel=\"noreferrer\"><img src=\"uploads/images/social_telegram.png\" alt=\"Telegram\"/></a></li><li><a href=\"https://www.instagram.com/\" target=\"_blank\" rel=\"noreferrer\"><img src=\"uploads/images/social_instagram.png\" alt=\"Instagram\"/></a></li></ul>",
            },
        },
        error: false
    });

    useEffect(() => {
        const getFooter = async () => {
            const { data, loading, error } = await getData(`footer`);
            await dispatch(updateFooter(data, now));

            if (!error) {
                setState({
                    ...state,
                    loading,
                    data,
                    error
                });
            } else {
                setState({
                    ...state,
                    loading,
                    error
                });
            }
        };

        if (!state.loading) {
            if (_persist.rehydrated) {
                let lastUpdate = moment(footer.lastUpdate, "YYYY-MM-DD")
                let yesterday = moment().subtract(1, 'days');
                if (lastUpdate < yesterday) {
                    getFooter().then(() => console.log("footer updated"));
                } else {
                    setState({
                        ...state,
                        loading: true,
                        data: footer,
                    });
                    // console.log("footer loaded from cache");
                }
            }
        }
    }, [_persist.rehydrated, state, dispatch, footer]);

    const cc = state.data.social.content.replace(/<img src="/g, `<img src="${IMAGE_URL}`);

    return (
        // !state.loading ? <SectionLoader type="spinningBubbles" color="#00b9d7"/> :
        <SkeletonTheme color="#47505e" highlightColor="#acacac">
            <Container className="mb-3 mt-3 rtl">
                <Row className="text-left">
                    <Col lg="3" sm="6" xs="12" className='d-flex flex-column footer-map-wrapper'>
                        <div>
                            <h5 className="text-center text-blue">برندها و شرکت ها</h5>
                        </div>
                        <div className="d-flex flex-column justify-content-between h-100">
                            {!state.loading ? <p className="text-justify text-white"><Skeleton count={8} /></p> :
                                <p className="text-justify text-white">
                                    {state.data.brands.map((item, i) =>
                                        <Fragment key={item.id}>
                                            <Link to={`/brand/${item.slag}`}
                                                className="footer-item-link">{item.name.trim()}</Link>
                                            {i + 1 !== state.data.brands.length && <span>، </span>}
                                        </Fragment>
                                    )}
                                </p>}
                            <p className="text-center text-white">
                                <Link to='/brands' className="footer-all-link"> همه برندها </Link>
                            </p>
                        </div>
                    </Col>
                    <Col lg="3" sm="6" xs="12" className='d-flex flex-column footer-map-wrapper'>
                        <div>
                            <h5 className="text-center text-blue"> آخرین شکایت های ثبت شده</h5>
                        </div>
                        <div className="d-flex flex-column justify-content-between h-100">
                            {!state.loading ? <p className="text-justify text-white"><Skeleton count={8} /></p> :
                                <p className="text-justify text-white">
                                    {state.data.complains.map((item, i) =>
                                        <Fragment key={item.id}>
                                            <Link to={`/complain/${item.id}`}
                                                className="footer-item-link">{item.title.trim()}</Link>
                                            {i + 1 !== state.data.complains.length && <span>، </span>}
                                        </Fragment>
                                    )}
                                </p>}
                            <p className="text-center text-white">
                                <Link to='/complains' className="footer-all-link"> همه شکایت ها </Link>
                            </p>
                        </div>
                    </Col>

                    <Col lg="4" sm="6" xs="12" className="footer-middle">
                        <div>
                            <h5 className="text-center text-blue">دسترسی سریع</h5>
                        </div>
                        <div className='container-fluid'>
                            <Row noGutters={true}>
                                <Col md="6" sm="12">
                                    <ul className='footer-menu'>
                                        <li><Link to='/about' className="footer-more-link"> درباره ما </Link></li>
                                        <li><Link to='/contact' className="footer-more-link"> تماس با ما </Link>
                                        </li>
                                        <li><Link to='/news-list' className="footer-more-link"> اخبـــار و تازه
                                            ها </Link></li>
                                        <li><Link to='/help' className="footer-more-link"> راهنما </Link></li>
                                        <li><Link to='/faqs' className="footer-more-link"> سوالات پرکاربرد </Link>
                                        </li>
                                        <li><Link to='/privacy-policy' className="footer-more-link"> سیاست ها و حریم خصوصی </Link></li>
                                        <li>
                                            <Link to='/rules' className="footer-more-link">
                                                مجوزها و قوانین مربوطه
                                            </Link>
                                        </li>
                                    </ul>
                                </Col>
                                <Col md="6" sm="12">
                                    <ul className='footer-menu'>
                                        <li><Link to='/login' className="footer-more-link">ورود / ثبت نام </Link>
                                        </li>

                                        <li><Link to={{ pathname: "https://company.farabazaar.ir" }} target='_blank' rel="noreferrer" className="footer-more-link"> ورود برند </Link>
                                        </li>
                                        <li>
                                            <Link to='/brand-help' className="footer-more-link">
                                                چرا به عنوان یک برند و شرکت باید در این سامانه ثبت نام کنیم؟
                                            </Link>
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                        </div>
                        <h6 className="text-center text-blue mt-4">ما را دنبال کنید</h6>
                        <div className="d-flex mt-3"
                            dangerouslySetInnerHTML={{
                                __html: cc
                            }}
                        />
                    </Col>
                    <Col lg="2" sm="6" xs="12" className="footer-middle">
                        <div>
                            <h5 className="text-center text-blue">مجوزها</h5>
                        </div>
                        {/* <div className='container-fluid text-center'>
                            <img id='nbqenbqewlaojxlzwlaorgvj' className='cursor-pointer' onClick={() => window.open("https://logo.samandehi.ir/Verify.aspx?id=224143&amp;p=uiwkuiwkaodsrfthaodsxlao", "Popup", "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")} alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=224143&amp;p=odrfodrfshwlnbpdshwlqfti' />
                        </div> */}
                    </Col>
                </Row>
            </Container>
        </SkeletonTheme>
    );
};

export default FooterPage;
